{
  "version": 1,
  "asset_id": "c4158d3f-ed88-48cd-a1a0-06da00ff5659",
  "project_id": "4dbb42ac-931e-41e9-ac57-3f509e458f26",
  "url": "/__l5e/assets-v1/c4158d3f-ed88-48cd-a1a0-06da00ff5659/core-placeholder.jpg",
  "r2_key": "a/v1/4dbb42ac-931e-41e9-ac57-3f509e458f26/c4158d3f-ed88-48cd-a1a0-06da00ff5659/core-placeholder.jpg",
  "original_filename": "core-placeholder.jpg",
  "size": 440989,
  "content_type": "image/jpeg",
  "created_at": "2026-09-06T15:00:40Z"
}
